var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.5 1L22 21L0.5 41","stroke":"#303030","strokeWidth":"1.4"}));
}

ArrowRight.defaultProps = {"width":"24","height":"42","viewBox":"0 0 24 42","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
